import styled from 'styled-components'
import BlurCont from 'Layout/BlurCont'

import AppButton from 'Components/AppButton'


import {
  GREY_BACKGROUND, PRIMARY_DARK_COLOR, TEXT_GREY,
  LOW_STAT_BG, MED_STAT_BG, HIGH_STAT_BG, TERTIARY_COLOR,
  FONT_BASE_COLOR, FORM_BG_COLOR,
} from '@CSSVars/colors'
import { BREAK_POINT_MD } from '@CSSVars/variables'


export const _EstimateContent = styled.div`
/*  margin-bottom: 128px;*/
  > div {
    margin-bottom: 0;
  }
`

export const _EstimateRow = styled.div`
  display: flex;

  > div {
    flex-basis: 50%;
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex-direction: column;
    > div {
      flex-basis: 100%;
    }
  }
`

export const _EstimateBlock = styled.div`
  height: 148px;
  margin-right: 12px;
  padding: 12px;
  background-color: ${GREY_BACKGROUND};
  border-radius: 10px;
  position: relative;

  .tooltipTrigger {
    position: absolute;
    top: 14px;
    right: 14px;
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-right: 0;
    margin-bottom: 24px;
  }
`

export const _BoxTitle = styled.div`
  height: 20px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;

  span {
    margin-left: 8px;
    font-weight: 600;
  }
`

export const _BoxSubtitle = styled.div`
  margin-top: 12px;
  font-size: 12px;
  line-height: 15px;
  color: ${TEXT_GREY};

  div {
    font-size: 12px;
    line-height: 15px;
    color: ${TEXT_GREY};
  }
`


export const _InsufficientTitle = styled.div`
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 35px;
  margin-bottom: 12px;
  color: ${PRIMARY_DARK_COLOR};
  p {
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    color: ${TEXT_GREY};
  }
`

export const _EstimateLoginCta = styled.div`
  margin-bottom: 32px;
  button {
    text-decoration: underline;
  }
`

export const _EstimatedNumber = styled.div`
  font-size: 38px;
  font-weight: 500;
  line-height: 35px;
  color: ${PRIMARY_DARK_COLOR};
`


export const _StatBar = styled.div`
  width: ${({ low, high }) => (
    low ? '70%' : high ? '100%' : '85%'
  )};
  height: 44px;
  padding: 0 14px;
  margin-bottom: 8px;
  border-radius: 10px;
  background-color: ${({ low, high }) => (
    low ? LOW_STAT_BG : high ? HIGH_STAT_BG : MED_STAT_BG
  )};

  display: flex;
  align-items: center;

  &:last-child {
    margin-bottom: 0;
  }
  span, div {
    color: white;
    &:first-child {
      width: 45px;
    }
    &:last-child {
      font-weight: 600;
    }
  }
`


export const _SubsectionTitle = styled.div`
  margin-top: 48px;
  margin-bottom: 24px;
  h3 {
    margin-right: 6px;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
  }

  display: flex;
  align-items: center;
`

export const _InsufficientDataCta = styled.div`
  padding: 10px 12px;
  display: flex;
  align-items: center;
  background-color: ${FORM_BG_COLOR};
  border-radius: 10px;
  border: 1px solid ${PRIMARY_DARK_COLOR};
  line-height: 24px;
  svg {
    margin-right: 12px;
    fill: ${FONT_BASE_COLOR};
  }
  button, a {
    margin-left: auto;
    margin-right: 0;
    text-decoration: underline;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {

    button, a {
      display: none;
    }
  }
`

export const _MobileAInsufficientDataContact = styled(AppButton)`
  display: none;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
    margin-top: 12px;
    display: block;
  }
`


export const _AvgStats = styled.div`
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex-direction: column;
  }
`

export const _AvgStatBlock = styled.div`
  flex-basis: 25%;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-bottom: 24px;
    flex-basis: 100%;
  }
`

export const _StatBlockTitle = styled.div`
  margin-bottom: 8px;
  font-weight: 500;
  line-height: 22px;
`

export const _StatBlockValue = styled(BlurCont)`
  margin-bottom: 2px;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 38px;
  position: relative;
  display: flex;
  align-items: center;

  >div {
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 38px;
  }
  ${({ higher, lower }) => ((higher || lower) && `
    &:before {
      content: "";
      // position: absolute;
      left:
      width: 0;
      height: 0;
      margin-right: 8px;
      border-top: ${higher ? '0 solid transparent' : `9px solid ${FONT_BASE_COLOR}`};
      border-bottom: ${lower ? '0 solid transparent' : `9px solid ${FONT_BASE_COLOR}`};
      border-right:  6px solid transparent;
      border-left:  6px solid transparent;
    }
    `)}
`

export const _StatBlockSubtitle = styled.div`
  font-weight: 500;
  color: ${TEXT_GREY};
`

export const _ComaparableCta = styled.div`
  padding: 12px;
  padding-left: 44px;
  margin-bottom: 32px;
  align-items: center;
  background-color: ${GREY_BACKGROUND};
  border-radius: 10px;
  line-height: 24px;

  position: relative;
  font-weight: 500;
  span {
    color: ${TERTIARY_COLOR};
  }
  svg {
    position: absolute;
    top: 12px;
    left: 12px;
  }

  button {
    text-decoration: underline;
    padding: 0;
  }
`

export const _BlurCont = styled(BlurCont)`
  display: inline-block;
`

